import { createFileRoute } from "@tanstack/react-router";

// RFC 9116 security contact file. Renew "Expires" before it passes (max. one year ahead).
const SECURITY_TXT = [
  "Contact: mailto:reg@foreign-council.org",
  "Expires: 2027-10-25T00:00:00.000Z",
  "Preferred-Languages: en, de",
  "Canonical: https://foreigncouncil.org/.well-known/security.txt",
  "Canonical: https://www.foreigncouncil.org/.well-known/security.txt",
  "Canonical: https://foreign-council.org/.well-known/security.txt",
  "Canonical: https://www.foreign-council.org/.well-known/security.txt",
  "",
].join("\n");

export const Route = createFileRoute("/.well-known/security.txt")({
  staticData: { sitemap: false },
  server: {
    handlers: {
      GET: async () =>
        new Response(SECURITY_TXT, {
          headers: {
            "Content-Type": "text/plain; charset=utf-8",
            "Cache-Control": "public, max-age=86400",
          },
        }),
    },
  },
});
